export default "__VITE_ASSET__BdRItc3C__"